import apiService from "./../../../../server";
import {
  ORG_MASTERS_PRIORITIES,
  ORG_MASTERS_PRIORITY_SUGGESTIONS,
  ORG_MASTERS_PROGRAMS,
  ORG_MASTERS_STATUSES,
  ORG_MASTERS_STATUS_FROM_SUGGESTION,
  ORG_MASTERS_STATUS_SUGGESTIONS,
  ORG_MASTERS_WORKFLOW,
  ORG_MASTERS_WORKFLOW_APPROVE,
  ORG_MASTERS_WORKFLOW_REJECT,
  ORG_MASTERS_WORKFLOW_SET_ACTIVE,
  ORG_MASTERS_WORKFLOW_MAKER_CHECKER_TEMPLATE,
  ORG_MASTERS_WORKFLOWS,
} from "../api";

export function fetchOrgPrograms() {
  return apiService.get(ORG_MASTERS_PROGRAMS);
}

export function saveOrgProgram(data: { key?: string; name: string; description?: string; active?: boolean }) {
  return apiService.put(ORG_MASTERS_PROGRAMS, data);
}

export function fetchOrgPriorities() {
  return apiService.get(ORG_MASTERS_PRIORITIES);
}

export function fetchOrgPrioritySuggestions() {
  return apiService.get(ORG_MASTERS_PRIORITY_SUGGESTIONS);
}

export function saveOrgPriority(data: {
  key?: string;
  suggestionKey?: string;
  name: string;
  level: number;
  active?: boolean;
}) {
  return apiService.put(ORG_MASTERS_PRIORITIES, data);
}

export function fetchOrgStatuses() {
  return apiService.get(ORG_MASTERS_STATUSES);
}

export function fetchOrgStatusSuggestions() {
  return apiService.get(ORG_MASTERS_STATUS_SUGGESTIONS);
}

export function saveOrgStatus(data: {
  key?: string;
  suggestionKey?: string;
  name: string;
  description?: string;
  startingStatus?: boolean;
  finalStatus?: boolean;
  active?: boolean;
}) {
  return apiService.put(ORG_MASTERS_STATUSES, data);
}

export function addOrgStatusFromSuggestion(suggestionKey: string) {
  return apiService.post(ORG_MASTERS_STATUS_FROM_SUGGESTION, null, { params: { suggestionKey } });
}

export function fetchOrgWorkflows() {
  return apiService.get(ORG_MASTERS_WORKFLOWS);
}

export function fetchOrgWorkflow(workflowKey: string) {
  return apiService.get(ORG_MASTERS_WORKFLOW, { params: { workflowKey } });
}

export function saveOrgWorkflow(data: object) {
  return apiService.put(ORG_MASTERS_WORKFLOW, data);
}

export function approveOrgWorkflow(workflowKey: string) {
  return apiService.post(ORG_MASTERS_WORKFLOW_APPROVE, null, { params: { workflowKey } });
}

export function rejectOrgWorkflow(workflowKey: string) {
  return apiService.post(ORG_MASTERS_WORKFLOW_REJECT, null, { params: { workflowKey } });
}

export function setOrgWorkflowActive(workflowKey: string, active: boolean) {
  return apiService.post(ORG_MASTERS_WORKFLOW_SET_ACTIVE, null, { params: { workflowKey, active } });
}

export function fetchMakerCheckerTemplate() {
  return apiService.get(ORG_MASTERS_WORKFLOW_MAKER_CHECKER_TEMPLATE);
}
